
import { ISession } from '../../state/stores/Session/SessionModel';
import { useStores } from '../useStores';


export const useIsReadySession = (session: ISession) => {

  const rootStore = useStores();
  let loadingContent = false;
  let errorContent = false;
  const contentId : (string | null)[] | null = session?.sessionSteps && session.sessionSteps.map(s => {
    if(['CONTENT_AUDIO','CONTENT_VIDEO','CONTENT_TEXT', 'QUESTION','SURVEY','EXERCISE'].includes(s.contentType)) {
      return s.contentId;
    } else {
      return null;
    }
  }).filter(x=>x);


  if(contentId && contentId.length > 0) {
    if(rootStore?.content.isReadyPlural(contentId)) {
      loadingContent = false;
    } else {
      loadingContent = true;
    }
    if(rootStore?.content.hasErrorPlural(contentId)) {
      errorContent = true;
    } else {
      errorContent = false;
    }
  }


  const loading = loadingContent;
  const error = errorContent;



  return {loading, error};
};


